const getContactWithIntegrationTeamLink = (isTrial: boolean): string =>
  isTrial
    ? `https://share.hsforms.com/1XzWcbcXxQn-Zlpxl1RfwPw3is1h`
    : `https://share.hsforms.com/1vG9XJwa3Sk2lWljCDHV50Q3is1h`;

export default getContactWithIntegrationTeamLink;
